export default __webpack_public_path__ + "static/media/kitchen1-1440w.b7e79531.webp";